import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors, Elevation, getSpacing } from '../utils';
import CloseIcon from '../assets/images/cross-close.svg';
import { Image } from './Image';

const ModalWrapper = styled.div`
  align-items: flex-start;
  background-color: transparent;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 1;
  padding: 130px 0 0;
  position: fixed;
  top: 0;
  transition: all 200ms;
  width: 100%;
  z-index: ${Elevation.ModalWrapper};

  &:after {
    content: '';
    background: ${colors.g05};
    height: 100%;
    width: 100%;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${Elevation.ModalWrapper - 1};
    opacity: 0.8;
  }
`;

const ModalContent = styled.div`
  background-color: ${colors.w01};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin: ${props => getSpacing(props.margin)};
  min-width: 610px;
  padding: ${props => getSpacing(props.padding)};
  position: relative;
  z-index: ${Elevation.ModalContent};
`;

const ModalClose = styled.div`
  cursor: pointer;
  height: 40px;
  position: absolute;
  right: 8px;
  top: 8px;
  width: 40px;
  z-index: ${Elevation.ModalContent};
`;

export const Modal = props => {
  const { children, toggleModal, closeButton } = props;

  return (
    <ModalWrapper {...props} padding={{ top: 'xl' }}>
      <ModalContent {...props}>
        {closeButton && (
          <ModalClose onClick={toggleModal} padding={{ right: 'medium', top: 'small' }}>
            <Image width="40px" height="40px" src={CloseIcon} />
          </ModalClose>
        )}
        {children}
      </ModalContent>
    </ModalWrapper>
  );
};

Modal.defaultProps = {
  closeButton: true,
  margin: 'none',
  padding: 'none',
  toggleModal: () => {}
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  closeButton: PropTypes.bool,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  toggleModal: PropTypes.func
};
